import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { HttpErrorHandler, HandleError } from './http-error-handler.service';

import { MessageListItem } from '../models/application';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  private _logging = environment.logging;
  private _apiSettings = environment.restAPI;
  private _messageSettings = environment.messages;
  private _baseServiceUrl = '';
  private _handleError: HandleError;

  constructor(@Inject('BASE_URL') baseUrl: string, private _httpClient: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this._baseServiceUrl = (this._apiSettings.useStaticUrl ? this._apiSettings.staticUrl : baseUrl) + this._apiSettings.urlSuffix;
    this._handleError = httpErrorHandler.createHandleError('ApplicationService');
  }

  public getWelcomeMessageList(companyCode: string): Observable<MessageListItem[]> {
    const serviceUrl: string = this._baseServiceUrl + 'Application/GetWelcomeMessages';
    if (this._logging.serviceCallTraceLog) {
      console.log('ApplicationService.getWelcomeMessages :: serviceUrl = ' + serviceUrl);
    }

    return this._httpClient.post<Array<MessageListItem>>(serviceUrl, {companyCode: companyCode}).pipe(
      retry(this._apiSettings.retryCount),
      catchError(this._handleError('getWelcomeMessages', []))
    );
  }

  public getTemporaryMessageList(companyCode: string): Observable<MessageListItem[]> {
    const serviceUrl: string = this._baseServiceUrl + 'Application/GetTemporaryMessages';
    if (this._logging.serviceCallTraceLog) {
      console.log('ApplicationService.getTemporaryMessages :: serviceUrl = ' + serviceUrl);
    }

    return this._httpClient.post<Array<MessageListItem>>(serviceUrl, {companyCode: companyCode}).pipe(
      retry(this._apiSettings.retryCount),
      catchError(this._handleError('getTemporaryMessages', []))
    );
  }

  //01/10/2023 - 1098-E Message
  public getGeneralMessageList(companyCode: string, webpage: string): Observable<MessageListItem[]> {
    const serviceUrl: string = this._baseServiceUrl + 'Application/GetGeneralMessages';
    if (this._logging.serviceCallTraceLog) {
      console.log('ApplicationService.getGeneralMessages :: serviceUrl = ' + serviceUrl);
    }

    return this._httpClient.post<Array<MessageListItem>>(serviceUrl, {companyCode: companyCode, webpage: webpage}).pipe(
      retry(this._apiSettings.retryCount),
      catchError(this._handleError('getGeneralMessages', []))
    );
  }

  public getInstructionMessageList(participantId: number): Observable<MessageListItem[]> {
    const serviceUrl: string = this._baseServiceUrl + 'Application/GetInstructionMessage';
    if (this._logging.serviceCallTraceLog) {
      console.log('ApplicationService.getInstructionMessages :: serviceUrl = ' + serviceUrl);
    }

    return this._httpClient.post<Array<MessageListItem>>(serviceUrl, {participantId: participantId}).pipe(
      retry(this._apiSettings.retryCount),
      catchError(this._handleError('getInstructionMessages', []))
    );
  }

  public getSchoolLoanProgramMessageList(participantId: number): Observable<MessageListItem[]> {
    const serviceUrl: string = this._baseServiceUrl + 'Application/GetSchoolLoanProgramMessages';
    if (this._logging.serviceCallTraceLog) {
      console.log('ApplicationService.getSchoolLoanProgramMessages :: serviceUrl = ' + serviceUrl);
    }

    return this._httpClient.post<Array<MessageListItem>>(serviceUrl, {participantId: participantId}).pipe(
      retry(this._apiSettings.retryCount),
      catchError(this._handleError('getSchoolLoanProgramMessages', []))
    );
  }

  public getPaymentMessageList(loanCode: string = null, schoolId: string = null): Observable<MessageListItem[]> {
    const serviceUrl: string = this._baseServiceUrl + 'Application/PaymentMessage';

    if (this._logging.serviceCallTraceLog) {
      console.log('ApplicationService.getPaymentMessagesList :: serviceUrl = ' + serviceUrl);
    }

    return this._httpClient.post<Array<MessageListItem>>(serviceUrl, {loanCode: loanCode, schoolId: schoolId}).pipe(
      retry(this._apiSettings.retryCount),
      catchError(this._handleError('getPaymentMessagesList', []))
    );
  }

  getMessageListItemDisplayClass(item: MessageListItem): string {
    if (item !== undefined && item !== null && item.displayClass !== null && item.displayClass.length > 0) {
      return item.displayClass;
    } else {
      return this._messageSettings.defaultMessageListItemDisplayClass;
    }
  }
}
